import * as constants from './constants';

const initialState = {
  isFetching: false,
  suggestions: [],
  selectedDestination: null,
  validationError: ''
};

export default function DestinationSuggestions(state = initialState, action) {
  switch (action.type) {
    case constants.FETCH_DESTINATIONS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case constants.FETCH_DESTINATIONS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        suggestions: action.data
      })
    case constants.FETCH_DESTINATIONS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    case constants.DESTINATIONS_CLEARED:
      return Object.assign({}, state, {
        suggestions: []
      })
    case constants.DESTINATION_SELECTED:
      return Object.assign({}, state, {
        selectedDestination: action.data,
        validationError: ''
      })
    case constants.VALIDATION_ERROR:
      return Object.assign({}, state, {
        validationError: action.data
      })
    default:
      return state;
  }
}
